import { Info } from "lucide-react";
import { Badge } from "@/core/components/ui/badge";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { useStAdjustmentsSection } from "./st-adjustments-section";

export const StAdjustmentsPreviewHeader = () => {
  const { byTechnician, totals } = useStAdjustmentsSection();

  return (
    <Stack
      direction="row"
      align="center"
      justify="between"
      fullWidth
      gap="md"
      className="shrink-0 border-b border-stroke-tertiary px-4 py-3"
    >
      <Stack gap="xs" className="min-w-0 shrink-0">
        <Stack direction="row" align="center" gap="sm">
          <Typography variant="subtitleW3">
            {totals?.pending ?? 0} lines to push
          </Typography>
          <Badge variant="gray" size="sm" className="shrink-0">
            Example data
          </Badge>
        </Stack>
        <Typography variant="captionW1" textColor="tertiary">
          {byTechnician.length} technicians with lines pending
        </Typography>
      </Stack>
      <Stack
        direction="row"
        align="start"
        justify="end"
        gap="sm"
        className="min-w-0 flex-1"
      >
        <Info
          aria-hidden="true"
          className="mt-0.5 h-4 w-4 shrink-0 text-secondary-text"
        />
        <Typography
          variant="bodyW2"
          textColor="secondary"
          className="min-w-0 text-right leading-normal"
        >
          <span className="block">
            You can now push your commissions back to ServiceTitan for accurate
            job costing.
          </span>
          <span className="block">
            Let us know if you'd like to enable for your account.
          </span>
        </Typography>
      </Stack>
    </Stack>
  );
};
